import React from "react";
import { useSelector } from "react-redux";

import { Impulse } from "~/tools/impulse";

import { isPlayground } from "../../../../app/state/config/ConfigSelectors";
import type { MonitorCheckStatus } from "../../../../common/openapi";
import { useExplorationDrawerState } from "../../../../components/react/drawer/use-exploration-drawer-state";
import { Link } from "../../../../components/react/styled/StyledComponents";

interface MonitorIntroProps {
	monitorStatus: MonitorCheckStatus;
}

export const MonitorIntro: React.FC<MonitorIntroProps> = ({ monitorStatus }) => {
	const explorationDrawer = useExplorationDrawerState();
	const playground = useSelector(isPlayground);

	return (
		<div className="xxl:max-w-3/4 py-4" data-testid="monitor-intro">
			<h2 className="mb-4 text-2xl leading-7">{monitorStatus.message}</h2>
			<p className="m-0 text-gray-800 leading-6" data-testid="monitor-description">
				{monitorStatus.monitorDescription}
				{playground ? null : (
					<>
						See the{" "}
						<Link
							data-testid="monitor-definition-link"
							onClick={() =>
								explorationDrawer.openMonitorPreview({
									title: monitorStatus.monitorName,
									monitorId: monitorStatus.monitorId.id,
									activeTab: Impulse("yaml"),
								})
							}
						>
							monitor definition
						</Link>{" "}
						for details.
					</>
				)}
			</p>
		</div>
	);
};
